import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M18 16L10 4L2 16L18 16Z" fill="#CCCCCC" /></svg>;
const ForwardRef = forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };